"use client";

import { Button } from "@/components/ui/button";
import { Lock } from "lucide-react";
import { useTranslations } from "next-intl";
import {
  type OAuthProvider,
  PROVIDER_ICONS,
  PROVIDER_TRANSLATION_KEYS,
} from "./PROVIDER_ICONS";

interface SocialLoginButtonProps {
  provider: OAuthProvider;
  onClick: () => void;
  disabled: boolean;
  isLastUsed: boolean;
  blocked: boolean;
}

export function SocialLoginButton({
  provider,
  onClick,
  disabled,
  isLastUsed,
  blocked,
}: SocialLoginButtonProps) {
  const t = useTranslations("common.auth");
  const isRecent = isLastUsed && !blocked;

  return (
    <div className="relative">
      <Button
        variant="outline"
        className={`relative h-14 w-full justify-start rounded-full border-gray-200 px-5 pr-20 shadow-none hover:bg-gray-50 ${
          isRecent ? "border-rose-300" : ""
        } ${blocked ? "opacity-60" : ""}`}
        onClick={onClick}
        disabled={disabled}
        aria-label={blocked ? t("inAppBrowserBlockedHint") : undefined}
      >
        {PROVIDER_ICONS[provider]}
        <span className="flex-1 text-center text-[15px] font-semibold text-gray-900 md:text-base">
          {t(PROVIDER_TRANSLATION_KEYS[provider])}
        </span>
        {/* "최근 로그인" lives inline at the right edge (NOL-style).
            Small rose-colored hint, doesn't overlap the centered label. */}
        {isRecent && (
          <span className="absolute right-5 top-1/2 -translate-y-1/2 text-[11px] font-medium text-rose-500">
            {t("recentlyUsed")}
          </span>
        )}
        {blocked && (
          <Lock className="absolute right-4 h-4 w-4 text-gray-500" />
        )}
      </Button>
    </div>
  );
}
